import DraggableModal from 'components/DraggableModal';
import React from 'react';

import SearchSSHClientKeysForm from './SearchSSHClientKeysForm';
import {openDialogOutside} from 'common/openDialogOutside';
import {DialogTypes} from 'common/names';

type SearchSSLKeysDialogProps = {
   header: string;
   onClose: () => void;
};

const SearchSSLKeysDialog = ({header, onClose}: SearchSSLKeysDialogProps) => {
   const openOutside = React.useCallback(
      () => openDialogOutside(DialogTypes.SearchSSHClientKeysDialog.id),
      []
   );

   return (
      <DraggableModal width={'md'} header={header} onClose={onClose} onLaunch={openOutside}>
         <SearchSSHClientKeysForm onClose={onClose} />
      </DraggableModal>
   );
};

export default SearchSSLKeysDialog;
